<template>
  <v-container fluid>
    <div>
      <v-row no-gutters justify="end">
        <v-btn
          @click="activeButtonMenu(), (shadow = !shadow)"
          :class="{
            'button-shadow': shadow,
            'main-button': user.buttonNotClickedYet,
          }"
          color="primary"
          style="font-size: 30px"
          fab
          large
          dark
        >
          <v-avatar :size="shadow ? 46 : 58" tile>
            <v-img :src="shadow ? '/img/casino.png' : '/img/logo.png'"></v-img>
          </v-avatar>
        </v-btn>
      </v-row>
      <slot-machine v-if="!shadow" />

      <selfies v-if="shadow" />
      <!-- <loyalty-card /> -->
      <!-- <v-btn
        fab
        depressed
        small
        class="ml-2 white--text"
        style="position: fixed; bottom: 10px; right: 10px; font-size: 20px"
        color="transparent"
        @click="activeButtonMenu()"
      >
        <v-avatar :size="shadow ? 46 : 58" tile>
          <v-img :src="shadow ? '/img/casino.png' : '/img/logo.png'"></v-img>
        </v-avatar>
      </v-btn> -->
      <v-btn
        fab
        depressed
        small
        class="ml-2 white--text text-none"
        style="
          position: fixed;
          bottom: 10px;
          right: calc(50vw - 25px);
          font-size: 20px;
        "
        color="transparent"
        @click="$store.commit('setDialogContact', true)"
      >
        💌
        <span v-if="!user.emailSent">(+3⭐)</span>
      </v-btn>
      <v-switch
        v-model="lightMode"
        color="white"
        :label="lightMode ? '🌞' : '🌛'"
        style="position: fixed; bottom: 0; left: 0"
        hide-details
        class="pa-4"
      ></v-switch>
    </div>
  </v-container>
</template>

<script>
import SlotMachine from "../components/SlotMachine.vue";
import Selfies from "../components/Selfies.vue";
import LoyaltyCard from "../components/LoyaltyCard.vue";

import { mapState } from "vuex";

export default {
  metaInfo() {
    return {
      meta: [
        {
          name: "theme-color",
          content: this.color,
        },
      ],
    };
  },
  data() {
    return {};
  },
  methods: {
    activeButtonMenu() {
      if (!this.user.buttonCliked)
        this.$store.dispatch("updateUserButtonNotClickedYet");
    },
  },
  computed: {
    ...mapState(["slotMachineIsRunning", "user", "customer"]),
    color() {
      if (this.shadow) {
        return "#ffa34d";
      } else if (this.lightMode) {
        return "#62A0F0";
      } else {
        return "#021F23";
      }
    },
    shadow: {
      get() {
        return this.$store.state.shadow;
      },
      set(val) {
        return this.$store.commit("setShadow", val);
      },
    },
    lightMode: {
      get() {
        return this.$store.state.lightMode;
      },
      set(val) {
        return this.$store.commit("setLightMode", val);
      },
    },
  },
  created() {
    if (this.$route.params) {
      if (this.$route.params.customer)
        if (this.$route.params.cup)
          this.$store.dispatch("getCustomer", this.$route.params.customer);
      this.$store.dispatch("getSelfies", this.$route.params);
    }

    this.$store.commit("setRouteParams", this.$route.params);
    if (this.user.new) this.$router.push("/introduction");
  },
  components: {
    SlotMachine,
    Selfies,
    LoyaltyCard,
  },
};
</script>

<style>
@font-face {
  font-family: josefinSans;
  src: url("../assets/static/JosefinSans-Regular.ttf");
}
* {
  font-family: josefinSans;
}
.v-card,
.v-dialog {
  border-radius: 20px !important;
}
.button-shadow {
  box-shadow: 0px 3px 15px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 50px #d4f8e8,
    0px 3px 15px 50px rgba(0, 0, 0, 0.2), 0px 0px 0px 200px #f67575,
    0px 3px 15px 200px rgba(0, 0, 0, 0.2), 0px 0px 0px 600px #ffa34d,
    0px 3px 15px 600px rgba(0, 0, 0, 0.2) !important;
}

/* * {
  border: solid 1px red;
} */

@keyframes zoominout {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.9);
  }
  100% {
    transform: scale(1);
  }
}

.number-of-cups {
  display: inline-block;
}
.main-button {
  animation: zoominout 1s infinite;
}
</style>
